module.exports = __webpack_public_path__ + "img/public/siteImages/verifyTick.svg?756d1979";